import HelpIcon from '@material-ui/icons/Help';
import styled from 'styled-components';

export const QuestionIcon = styled(HelpIcon)`
  font-size: 30px;
  margin: 0 10px -5px 0;
  color: deepskyblue;
`;
